import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatNativeDateModule } from "@angular/material/core";
import { MatIconModule } from "@angular/material/icon";
import { CommonModule } from "@angular/common";
import { MAT_DATEPICKER_SCROLL_STRATEGY } from "@angular/material/datepicker";
import { Overlay, RepositionScrollStrategy } from "@angular/cdk/overlay";

@Component({
  selector: "app-glo-date-picker",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    MatIconModule,
    ReactiveFormsModule,
  ],
  providers: [
    {
      provide: MAT_DATEPICKER_SCROLL_STRATEGY,
      useFactory: (overlay: Overlay) => () =>
        overlay.scrollStrategies.reposition(),
      deps: [Overlay],
    },
  ],
  templateUrl: "./glo-date-picker.component.html",
  styleUrls: ["./glo-date-picker.component.scss"],
  encapsulation: ViewEncapsulation.None, // Important for Material overrides
})
export class GloDatePickerComponent {
  @Input() placeholder: string = "Tue, Jan 6, 2026";
  @Input() label: string = "";
  @Input() disabled: boolean = false;
  @Input() minDate: Date | null = null;
  @Input() maxDate: Date | null = null;
  @Input() formControlInput: FormControl = new FormControl();
  @Input() classes?: string = "";
  @Input() isRequired: boolean | undefined = false;
  @Output() dateChange = new EventEmitter<Date>();

  constructor(private overlay: Overlay) {}

  onDateChange(date: Date | null): void {
    if (date) {
      this.dateChange.emit(date);
    }
  }
}
